import { render, staticRenderFns } from "./ReturnTimelineStatus.vue?vue&type=template&id=53dcb730&"
import script from "./ReturnTimelineStatus.vue?vue&type=script&lang=js&"
export * from "./ReturnTimelineStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53dcb730')) {
      api.createRecord('53dcb730', component.options)
    } else {
      api.reload('53dcb730', component.options)
    }
    module.hot.accept("./ReturnTimelineStatus.vue?vue&type=template&id=53dcb730&", function () {
      api.rerender('53dcb730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnTimelineStatus.vue"
export default component.exports